import { css } from '@emotion/react';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonComponent } from '~/_shared/baseComponents/buttons';
import { OverlayLoaderComponent } from '~/_shared/components/overlay/overlayLoader.component';
import {
  HOME_ROUTE, LOGIN_ROUTE,
} from '~/_shared/constants/routes';
import { useTranslation } from '~/_shared/utils/hooks';
import { AppErrorPageWrapperComponent } from '~/app/pages/errorPage/wrapper/appErrorPageWrapper.component';
import { AuthorizationPageWrapperComponent } from '~/authorization/pageWrapper/authorizationPageWrapper.component';

const textWrapperStyle = css({
  maxWidth: 680,
  flexDirection: 'column',
  display: 'flex',
  gap: 20,
});

export const SsoPageComponent = ({
  isLoading,
  error,
}: {
  isLoading: boolean;
  error?: string;
}) => {
  const [t] = useTranslation();
  const navigate = useNavigate();

  const onBackToLogin = useCallback(() => {
    navigate(LOGIN_ROUTE, { state: { from: HOME_ROUTE } });
  }, [navigate]);

  if (error) {
    return (
      <AppErrorPageWrapperComponent>
        <div css={textWrapperStyle}>
          {error}
          <ButtonComponent
            text={t('Back to Login')}
            onClick={onBackToLogin}
          />
        </div>
      </AppErrorPageWrapperComponent>
    );
  }

  return (
    <AuthorizationPageWrapperComponent>
      {isLoading && (
        <OverlayLoaderComponent loaderSize={70} />
      )}
    </AuthorizationPageWrapperComponent>
  );
};
